@if (label) {
  <div class="label">{{ label }}</div>
}

<section>
  <mat-slider [step]="step" [min]="min" [max]="max" [disabled]="disabled">
    <input matSliderThumb [value]="sliderValue" (input)="inputChange($event)" />
  </mat-slider>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input
      matInput
      class="input-field"
      type="number"
      min="{{ min }}"
      max="{{ max }}"
      step="{{ step }}"
      [value]="sliderValue"
      [disabled]="disabled"
      (input)="inputChange($event)"
    />

    @if (suffix) {
      <span matTextSuffix [ngClass]="{ 'suffix-disabled': disabled }">{{ suffix }}</span>
    }
  </mat-form-field>
</section>
